import { get } from 'lodash-es'

// The sorting logic below was updated in POS-6119 to handle cases where product names
//  have prepended numbers. E.g. "1. Apple", "2. Banana", "3. Cucumber", "3. Carrot
// This was done using ChatGPT. See https://chat.openai.com/share/30eda132-43a3-4a71-8518-da76ae9b90b1
// Testing with different cases: https://jsfiddle.net/y53akv0b/

export const sortByKey = (
    a: {
        [key: string]: any
    },
    b: {
        [key: string]: any
    },
    key: string,
) => {
    const valueA = get(a, key)
    const valueB = get(b, key)

    if (typeof valueA === 'string' && typeof valueB === 'string') {
        // Extract the number at the beginning of string valueA. 'undefined' if no number.
        const numA = Number(valueA.match(/^\d+/)?.[0])
        // Extract the number at the beginning of string valueB. 'undefined' if no number.
        const numB = Number(valueB.match(/^\d+/)?.[0])

        // Check if both numA and numB are valid numbers.
        if (!isNaN(numA) && !isNaN(numB)) {
            // If both strings (valueA & valueB) have numbers, compare the numerical values (numA & numB).
            if (numA === numB) {
                // Same numbers, so use localeCompare to compare the values (valueA & valueB) as strings.
                // E.g. If valueA = "3. Cucumber" and valueB = "3. Carrot", then numA & numB = 3.
                // Therefore, valueB will come before valueA determined by localeCompare.
                return valueA.localeCompare(valueB)
            } else {
                // Different numbers, so use simple < or > compare to compare the numbers (numA & numB).
                // E.g. If valueA = "1. Apple" and valueB = "2. Banana", then numA = 1 and numB = 2
                // and numA < numB, so we return -1. Therefore, valueA will come before valueB.
                if (numA < numB) {
                    return -1
                }
                if (numA > numB) {
                    return 1
                }
                return 0
            }
        } else if (!isNaN(numA)) {
            // If only numA is a valid number, valueA should come before valueB.
            return -1
        } else if (!isNaN(numB)) {
            // If only numB is a valid number, valueB should come before valueA.
            return 1
        } else {
            // If neither of the strings (valueA & valueB) has a number, use localeCompare to compare.
            return valueA.localeCompare(valueB)
        }
    } else {
        // If valueA and valueB are not both strings, then use simple < or > compare.
        if (valueA < valueB) {
            return -1
        }
        if (valueA > valueB) {
            return 1
        }
        return 0
    }
}
